<!--
     Copyright (c) 2024 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->

<clr-radio-container>
    <clr-radio-wrapper *ngFor="let item of items">
        <input type="radio"
               clrRadio
               #input
               *ngIf="item.value !== 'EMPTY'"
               [id]="item.value"
               [value]="item.value"
               [name]="filterProperty"
               [(ngModel)]="selectedItem"
               (ngModelChange)="onRadioChecked()"/>
        <label [for]="item.value"
               [ngClass]="{'divider': item.value === 'EMPTY'}">
            <ng-container *ngIf="item.value !== 'EMPTY'">
                {{ item.label }}
            </ng-container>
        </label>
    </clr-radio-wrapper>
</clr-radio-container>

<button type="button"
        class="btn btn-sm btn-outline"
        (click)="onButtonClick()"
        [disabled]="!selectedItem">
    {{ "filter.clear.button.text" | vtranslate }}
</button>
